export default __webpack_public_path__ + "static/media/cedula_antigua.18f6bc36.svg";